import React from 'react';
import PropTypes from 'prop-types';

const FeeTip = ({ i18n, commissionStatus, bnbAmount }) => {
  if (commissionStatus === 0) {
    return (
      <span>
        {i18n['exchange-fee-BnbPaymentNotOpen'] || 'Not using BNB for fees'}
      </span>);
  } if (commissionStatus === 1) {
    if (bnbAmount >= 1) {
      return (
        <span>
          {i18n['exchange-fee-BnbPayment'] || 'Using BNB for fees'}
        </span>);
    } if (bnbAmount > 0) {
      return (
        <span>
          {i18n['exchange-fee-BnbFundsLow'] || 'BNB funds low'}
        </span>);
    }
    return (
      <span>
        {i18n['exchange-fee-NoBnb'] || 'No BNB available'}
      </span>);
  }
  return null;
};

FeeTip.propTypes = {
  i18n: PropTypes.object.isRequired,
  commissionStatus: PropTypes.number.isRequired,
  bnbAmount: PropTypes.string.isRequired,
};

export default FeeTip;
